import { EditOutlined } from "@mui/icons-material"
import {
  Button,
  Chip,
  Stack,
  type StackProps,
  styled,
  Typography,
} from "@mui/material"
import { Link } from "react-router"
import type { DeepReadonlyArray } from "rxdb"

const StyledRoot = styled(Stack)(({ theme }) => ({
  alignItems: "flex-start",
  gap: theme.spacing(0.5),
}))

export const MetadataItemList = ({
  values,
  label,
  onEditClick,
  emptyLabel = "Unknown",
  ...rest
}: {
  values?: DeepReadonlyArray<{ label?: string; to?: string }>
  label: string
  emptyLabel?: string
  onEditClick?: () => void
} & StackProps) => {
  return (
    <StyledRoot {...rest}>
      <Stack
        sx={{
          flexDirection: "row",
          gap: 1,
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            fontWeight: "bold",
          }}
        >
          {label}
        </Typography>
        {!!onEditClick && (
          <Button
            size="small"
            variant="text"
            onClick={onEditClick}
            startIcon={<EditOutlined />}
          >
            Edit
          </Button>
        )}
      </Stack>
      <Stack
        sx={{
          flexDirection: "row",
          gap: 1,
          flexWrap: "wrap",
        }}
      >
        {!values?.length && (
          <Typography variant="caption">{emptyLabel}</Typography>
        )}
        {values?.map((item, index) => (
          <Chip
            label={item.label ?? "unknown"}
            size="medium"
            key={index}
            style={{
              maxWidth: 320,
            }}
            {...(item.to && {
              clickable: true,
              to: item.to,
              component: Link,
            })}
          />
        ))}
      </Stack>
    </StyledRoot>
  )
}
